<template>
  <div
    class="ushk-flash_item J_flash_item"
    :class="[
      {
        'is-relevance': data.isRelevanceActive,
        'is-relevance-important': data.isRelevanceImportant,
      },
    ]"
    :data-relevance="data.type === 0 && data.relevance ? data.relevance : null"
  >
    <div class="ushk-flash_h">
      <div class="ushk-flash_icon"></div>
      <div class="ushk-flash_time">{{ data.time_view }}</div>
    </div>
    <div class="ushk-flash_b">
      <div
        v-if="data.type === 0"
        :class="[
          data.type === 0 ? { important: data.important } : '',
          data.data.star
            ? data.data.type === 1
              ? `star${data.data.star}`
              : data.data.star > 2
              ? 'important'
              : ''
            : '',
        ]"
      >
        <div
          class="ushk-flash_text"
          :class="{ 'is-only-text': !data.data.pic }"
        >
          <div class="ushk-flash_text-box" @click="onRecord">
            <!-- <p v-html="data.data.content"></p> -->
            <div class="ushk-flash_text-box_title" v-if="data.data.title">
              <b>{{ data.data.title }}</b>
            </div>
            <span class="ushk-flash_text-tag" v-if="data.data.tag">{{ data.data.tag }}</span>
            <p v-html="flashFormat(data)"></p>
            <a
              v-if="data.data.link"
              :href="data.data.link"
              target="_blank"
              class="ushk-flash_text-more1"
              >阅读更多<i class="ushk-icon ushk-icon_rightArrow"></i
            ></a>
          </div>
          <!-- <img
            style="margin-top: 7px"
            v-if="data.data.sentiment"
            :src="require(`@/assets/img/${data.data.sentiment}.png`)"
            alt=""
          /> -->
        </div>
        <div v-if="data.data.pic" class="ushk-flash_attach">
          <viewer
            v-if="data.data.pic"
            class="ushk-flash_image"
            :options="{ url: 'data-source' }"
          >
            <img
              v-if="data.isSocket"
              :src="data.data.picLite"
              :data-source="data.data.pic"
            />
            <img
              v-else
              v-lazy="data.data.picLite"
              :data-source="data.data.pic"
            />
          </viewer>
        </div>
      </div>
      <template v-else-if="data.type === 1 || data.type === 3">
        <div class="ushk-flash_data">
          <h4 class="ushk-flash_data-title">
            <div class="ushk-flash_data-country">
              <img
                v-if="data.isSocket"
                :src="`//cdn.jin10.com/assets/img/commons/flag/${data.data.country}.png`"
              />
              <img
                v-else
                v-lazy="
                  `//cdn.jin10.com/assets/img/commons/flag/${data.data.country}.png`
                "
              />
            </div>
            <span>{{ data.data.content }}</span>
          </h4>
          <div class="ushk-flash_data-text">
            <p><span>前值：</span>{{ data.data.previous || "--" }}</p>
            <p><span>预期：</span>{{ data.data.consensus || "--" }}</p>
            <p class="ushk-flash_data-published">
              <span>公布：</span>
              <b :class="data.data.evaluateClass">{{ data.data.actual }}</b>
            </p>
          </div>
          <div :id="data.data.data_id" class="ushk-flash_data-correction">
            {{ data.data.revised }}
          </div>
          <div class="ushk-flash_data-wrap">
            <div class="ushk-flash_data-vote">
              <star tag-name="p" :width="data.data.star" />
            </div>
            <div class="ushk-flash_data-tag ushk-tag_trend" v-if="data.data.show_affect && data.data.country !== '中国'">
              <p :class="data.data.evaluateClass">
                <span class="ushk-btn J_kind_tag" :data-trend="data.data.trend"
                  ><em class="J_kind_trend">{{ data.data.evaluate }}</em>
                  <i class="J_kind_trendType">{{ data.data.kind }}</i></span
                >
              </p>
            </div>
          </div>
          <p class="ushk-flash_data-pubdate">{{ data.data.pubDate }}</p>
        </div>
      </template>
      <div class="ushk-flash-remark-con">
        <img v-if="data.data.sentiment" :src="require(`@/assets/img/${data.data.sentiment}.png`)" alt="">
        <ul v-if="data.remark" class="ushk-flash-remark">
          <li
            v-for="(remarkItem, index) in data.remark"
            class="ushk-flash-remark__item"
            @click.stop="onRemarkClick(remarkItem)"
            v-if="!remarkItem.lock"
          >
            <i
              class="ushk-icon"
              :class="`ushk-icon_remark-${remarkItem.type}`"
            ></i>
            <span>{{ remarkItem.title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyList from './CompanyList'
import { fetch } from '@/commons/fetch'
import { base64EncArr, strToUTF8Arr } from './baseFn'
import { flashFormat } from '@/commons/utils'
let url =
  process.env.NODE_ENV === 'development' ||
  window.location.href.includes('test')
    ? 'https://behavior-collection-18924143967-testing.jin10.com'
    : '//log-agent.jin10.com'

let env = process.env.NODE_ENV === 'development' ||
  window.location.href.includes('test') ? 'env' : 'prod'

export default {
  name: '',
  components: {
    CompanyList
  },
  props: {
    data: Object,
    isShowCompanyList: {
      type: Boolean,
      default: true
    },
    did: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {}
  },
  created () {
  },

  methods: {
    onRecord (e) {
      if (e.target.localName === 'img') {
        let data = {
          app: 'ushknews',
          page_name: '美港电讯',
          module: '快讯',
          action: '点击',
          type: '图片广告',
          object: null,
          params: {
            url: e.target.src
          }
        }

        const protoStr = JSON.stringify([data])
        const u8Ary = strToUTF8Arr(protoStr)
        const b64Code = base64EncArr(u8Ary)

        fetch({
          url: url + '/v1/web/bin',
          data: b64Code.buffer,
          type: 'post',
          headers: {
            'Content-Type': 'application/octet-stream',
            env,
            did: this.did
          },
          callback: (res) => {},
          success: (res) => {
            resolve(res.data)
          },
          error: () => {}
        })
      }
    },
    onRemarkClick (data) {
      if (data.type === 'link') {
        window.open(data.link, '_blank')
        return false
      }
      this.$emit('on-remark-click', data)
    },
    flashFormat
  }
}
</script>



// WEBPACK FOOTER //
// Message.vue?9e37aaf8